import Icon from '../../components/Icon.vue'

Icon.register({"regular/comment":{"width":512,"height":512,"paths":[{"d":"M256 32C114.6 32 0 125.1 0 240 0 287.6 19.9 331.2 52.9 366.3 38 405.7 7 439.1 6.5 439.5-0.1 446.5-1.9 456.7 1.9 465.5S14.4 480 24 480C85.5 480 134 454.3 163.1 433.7 192 442.8 223.2 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM256 400C229.3 400 202.9 395.9 177.6 387.9L154.9 380.7 135.4 394.5C121.1 404.6 101.5 415.9 77.9 423.5 85.2 411.4 92.3 397.8 97.8 383.3L108.4 355.2 87.8 333.4C69.7 314.1 48 282.2 48 240 48 151.8 141.3 80 256 80S464 151.8 464 240 370.7 400 256 400z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/regular/comment.js